import style from "../../assets/scss/sub/mainWrapper.module.scss";
import { useEffect } from "react";
import { FloatingBtn } from "../common/button/FloatingBtn";
import { useFooter } from "../../hooks/hooks";

interface Props {
  showFooter: boolean;
  mainClassName: string;
  children: JSX.Element;
}

export function MainWrapper({ showFooter, mainClassName, children }: Props) {
  const { setShowFooter } = useFooter();

  useEffect(() => {
    setShowFooter(showFooter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className={`${style.main} ${mainClassName}`}>
      <FloatingBtn />
      {children}
    </main>
  );
}
